import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { registerFilter, updateFilter } from '../stateReducer/actions';
import { DataGridContext } from './context';
const propTypes = {
  /**
   * A function that returns the filter form control. It receives the current
   * value of the filter, and a function that can update the filter value.
   */
  children: PropTypes.func.isRequired,
  /**
   * The data key to use for the filter.
   */
  dataKey: PropTypes.string.isRequired,
  /**
   * The default value for the filter.
   */
  defaultValue: PropTypes.any,
  includeRow: PropTypes.func.isRequired,
  isActive: PropTypes.func.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
};
export default class DataGridCustomFilter extends Component {
  constructor() {
    super(...arguments);
    this.label = /*#__PURE__*/React.createRef();
    this.includeRow = /*#__PURE__*/React.createRef();
    this.isActive = /*#__PURE__*/React.createRef();
    this.handleUpdateFilter = value => {
      const {
        dispatch
      } = this.context;
      const {
        dataKey
      } = this.props;
      dispatch(updateFilter(dataKey, value));
    };
  }
  componentDidMount() {
    const {
      dispatch
    } = this.context;
    const {
      dataKey,
      label,
      defaultValue,
      includeRow,
      isActive
    } = this.props;
    this.label.current = label;
    this.includeRow.current = includeRow;
    this.isActive.current = isActive;
    dispatch(registerFilter({
      key: dataKey,
      label: this.label,
      defaultValue,
      includeRow: this.includeRow,
      isActive: this.isActive
    }));
  }
  componentDidUpdate(prevProps) {
    if (this.props.label !== prevProps.label) {
      this.label.current = this.props.label;
    }
    if (this.props.includeRow !== prevProps.includeRow) {
      this.includeRow.current = this.props.includeRow;
    }
    if (this.props.isActive !== prevProps.isActive) {
      this.isActive.current = this.props.isActive;
    }
  }
  render() {
    const {
      filter = {}
    } = this.context;
    const {
      dataKey,
      defaultValue,
      children
    } = this.props;
    const currentValue = filter[dataKey] ? filter[dataKey].value : defaultValue;
    return /*#__PURE__*/React.createElement(React.Fragment, null, children(currentValue, this.handleUpdateFilter));
  }
}
DataGridCustomFilter.propTypes = propTypes;
DataGridCustomFilter.contextType = DataGridContext;